import { useMemo } from "react";

import { useConfig } from "@jti/app-context";

import { MapApi } from "../../../services/map";

/**
 * React wrapper for {@link MapApi}. Resolves config from context and memoizes the
 * instance on config identity — the service does real work per instantiation.
 * Non-React callers should call `MapApi.init(config)` directly instead.
 */
export const useMapApi = (): MapApi => {
  const config = useConfig();

  return useMemo(() => MapApi.init(config), [config]);
};
